






























































































































































































































































































































































































































import Vue from 'vue'
import {
  dateObjToDateString,
  dateObjToTimeString,
  dateTimeStringToISO,
  isoToHumanDate,
  isoToHumanDateTime,
  dateStringToISO
} from '../../../util/date-time'
import { v4 as uuidv4 } from 'uuid'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { add, parseISO as dfnParseISO } from 'date-fns'
import distance from '@turf/distance'
import { Position } from '@capacitor/geolocation'

import EditPhotoGalleryComponent from '../../../components/EditPhotoGalleryComponent.vue'
import SeeCulvertsDialog from '../../../components/SeeCulvertsDialog.vue'
import {
  CulvertInspectionResult,
  CulvertInspectionActionRes,
  CulvertResult,
  RelationsRes,
  EntitiesWithPhotos
} from '../../../veg-common/apiTypes'
import { RiskI, ParseRiskSlider } from '../../../util/CalculateIssueRisk'
import { IsMobileDevice } from '../../../util/ParseUserAgent'
import { Point } from 'geojson'

export default Vue.extend({
  components: {
    ValidationObserver,
    ValidationProvider,
    EditPhotoGalleryComponent,
    SeeCulvertsDialog
  },
  data(): AddCulvertInspectionI {
    return {
      selectedCulvert: null,
      previousCulvertId: null,
      selectedActionsTaken: [],
      selectedCulvertStatus: null,
      inspectionToEdit: null,

      comments: '',
      selectedActionsRequired: [],
      date: dateObjToDateString(new Date()),
      time: dateObjToTimeString(new Date()),
      nextDate: dateObjToDateString(add(new Date(), { years: 1 })),
      dateDialog: false,
      timeDialog: false,
      nextDateDialog: false,
      confirmationDialog: false,
      fullCulvertList: [],
      pageLoading: true,
      photos: [],
      newPhotos: [],
      photosToRemove: [],
      photoLoading: false,
      riskSlider: 0,
      riskLabels: ['No Risk', 'Low', 'Medium', 'High'],
      isMobileDevice: IsMobileDevice(),
      actionsRequiredSelectMenu: false,
      actionsTakenSelectMenu: false,
      inspectionSaved: false,
      exitDialog: false,
      confirmedLeaving: false,
      routerNextPath: '',
      haveActionsTaken: false,
      haveActionsRequired: false
    }
  },
  computed: {
    culverts(): CulvertResult[] {
      return this.$typedStore.getters.culverts
    },
    culvertInspections(): CulvertInspectionResult[] {
      return this.$typedStore.getters.culvertInspections
    },
    relations(): RelationsRes {
      return this.$typedStore.getters.relations
    },
    watchPosition(): Position | null {
      return this.$typedStore.state.latestPosition
    },
    calculatedRiskScore(): RiskI {
      return ParseRiskSlider(this.riskSlider)
    },
    humanReadableDate(): string {
      return this.date ? isoToHumanDate(this.date) : ''
    },
    humanReadableNextDate(): string {
      return this.nextDate ? isoToHumanDate(this.nextDate) : ''
    },
    isSmallScreen(): boolean {
      return this.$vuetify.breakpoint.smAndDown
    },
    copyFollowUpButtonClass(): string {
      if (!this.isSmallScreen) {
        return 'd-flex justify-center'
      } else {
        return 'mt-0 pt-0'
      }
    },
    isClientUser(): boolean {
      if (this.$typedStore.getters.user) {
        return this.$typedStore.getters.user.userRoleId === 1
      }
      return false
    }
  },
  methods: {
    closeActionsTakenMenu() {
      this.actionsTakenSelectMenu = false
      //@ts-ignore
      this.$refs.actionsTaken.blur()
    },
    closeActionsRequiredMenu() {
      this.actionsRequiredSelectMenu = false
      // @ts-ignore
      this.$refs.actionsRequired.blur()
    },
    async validateInputs(): Promise<void> {
      //@ts-ignore
      let valid = await this.$refs.validator.validate()

      if (valid && this.calculatedRiskScore.score >= 0) {
        await this.saveInspection()
      } else {
        this.$typedStore.commit('setSnackbarParams', {
          type: 'error',
          msg: 'Form invalid.'
        })
      }
    },
    printDateReadableForCulvertSelect(date: string) {
      return isoToHumanDateTime(date)
    },
    sortCulvertList(userPosition?: Position): void {
      let app = this
      let listOfCulverts: CulvertWithDistanceToUser[] = []
      let userPoint: Point | null = null

      if (userPosition) {
        userPoint = {
          type: 'Point',
          coordinates: [
            userPosition.coords.longitude,
            userPosition.coords.latitude
          ]
        }
      }

      app.culverts.forEach((culvert) => {
        let distanceToInlet = -100
        let distanceToOutlet = -100
        if (userPoint) {
          distanceToInlet = distance(
            userPoint,
            (culvert.inlet_location as Point).coordinates
          )
          distanceToOutlet = distance(
            userPoint,
            (culvert.outlet_location as Point).coordinates
          )
        }

        listOfCulverts.push({
          culvert,
          distance:
            distanceToInlet <= distanceToOutlet
              ? distanceToInlet
              : distanceToOutlet
        })
      })

      if (listOfCulverts.length > 0) {
        let sortedList: CulvertWithDistanceToUser[]

        if (userPoint) {
          sortedList = listOfCulverts.sort(function (culvert1, culvert2) {
            return culvert1.distance - culvert2.distance
          })
        } else {
          //sort each culvert alphabetically to start, so that any culverts without an inspection are listed alphabetically in the dialog
          sortedList = listOfCulverts.sort(function (culvert1, culvert2) {
            var lowerCase1 =
              culvert1.culvert.site_culvert_id.toLocaleLowerCase()
            var lowerCase2 =
              culvert2.culvert.site_culvert_id.toLocaleLowerCase()
            return lowerCase1.localeCompare(lowerCase2)
          })
        }
        app.fullCulvertList = sortedList
      }
    },
    setFormData(): void {
      let toEdit: CulvertInspectionResult | null = this.inspectionToEdit
      if (toEdit) {
        this.comments = toEdit.comments
        this.date = dateObjToDateString(dfnParseISO(toEdit.inspection_date))
        this.time = dateObjToTimeString(dfnParseISO(toEdit.inspection_date))
        this.nextDate = dateObjToDateString(
          dfnParseISO(toEdit.next_inspection_date)
        )
        let foundCulvert = this.culverts.find((culvert) => {
          return toEdit ? toEdit.culvert === culvert.site_culvert_id : false
        })
        foundCulvert ? (this.selectedCulvert = foundCulvert.id) : null
        foundCulvert ? (this.previousCulvertId = foundCulvert.id) : null
        let foundCulvertStatus = this.relations.culvertStatuses.find(
          (status) => {
            return toEdit !== null &&
              toEdit.culvertStatus !== null &&
              toEdit.culvertStatus.toLowerCase() ===
                status.culvert_status.toLowerCase()
              ? status.culvert_status
              : false
          }
        )

        foundCulvertStatus
          ? (this.selectedCulvertStatus = foundCulvertStatus.id)
          : null

        this.haveActionsRequired =
          toEdit.actionsRequired !== null && toEdit.actionsRequired.length > 0
        this.haveActionsTaken =
          toEdit.actionsTaken !== null && toEdit.actionsTaken.length > 0

        this.selectedActionsRequired =
          this.relations.culvertRequiredActions.filter((action) => {
            return toEdit !== null && toEdit.actionsRequired !== null
              ? toEdit.actionsRequired.includes(action.inspection_action)
              : false
          })
        this.selectedActionsTaken = this.relations.culvertTakenActions.filter(
          (action) => {
            return toEdit !== null && toEdit.actionsTaken !== null
              ? toEdit.actionsTaken.includes(action.inspection_action)
              : false
          }
        )

        this.riskSlider = 0
        switch (toEdit.risk_score) {
          case 0:
            this.riskSlider = 0
            break
          case 1:
            this.riskSlider = 1
            break
          case 5:
            this.riskSlider = 2
            break
          case 10:
            this.riskSlider = 3
            break
        }
        this.photos = Array.from(toEdit.photos)
        this.newPhotos = []
        this.photosToRemove = []
      }
      this.pageLoading = false
    },
    async saveInspection(): Promise<void> {
      let app = this

      if (!app.$typedStore.getters.jwtContent) return
      if (!app.$typedStore.getters.jwtContent.data.userId) return
      if (!app.selectedCulvert) return
      if (!app.selectedCulvertStatus) return
      if (!app.previousCulvertId) return

      if (app.inspectionToEdit) {
        let result = await app.$rpc('callEditCulvertInspection', {
          id: app.inspectionToEdit.id,
          uuid: uuidv4(),
          //converts to utc automatically
          inspection_date: dateTimeStringToISO(app.date, app.time),
          next_inspection_date: dateStringToISO(app.nextDate), //make sure the timezone difference keeps same day
          culvertStatusId: app.selectedCulvertStatus,
          actionsTakenIds: app.selectedActionsTaken
            ? app.selectedActionsTaken.map((action) => action.id)
            : [],
          actionsRequiredIds: app.selectedActionsRequired
            ? app.selectedActionsRequired.map((action) => action.id)
            : [],
          risk_score: app.calculatedRiskScore.score,
          comments: app.comments,
          culvertId: app.selectedCulvert,
          previousCulvertId: app.previousCulvertId
        })

        if (result && !result.success) {
          app.$typedStore.commit('setSnackbarParams', {
            type: 'error',
            msg: 'Issue update failed.'
          })
          return
        }

        app.$typedStore.commit('setSnackbarParams', {
          type: 'success',
          msg: 'Issue updated successfully.'
        })

        for (let i = 0; i < app.newPhotos.length; i++) {
          await app.$rpc(
            'callPhotoUploadAddExisting',
            {
              parentId: app.inspectionToEdit.id,
              targetType: EntitiesWithPhotos.CulvertInspectionPhoto,
              fileType: app.newPhotos[i].type
            },
            app.newPhotos[i]
          )
        }

        for (let i = 0; i < app.photosToRemove.length; i++) {
          await app.$rpc('callPhotoRemove', {
            parentId: app.inspectionToEdit.id,
            targetType: EntitiesWithPhotos.CulvertInspectionPhoto,
            fileKey: app.photosToRemove[i]
          })
        }
        app.inspectionSaved = true
        app.$emit('requestUpdate', { edit: true })
        app.$router.push('/culvert-inspections')
      }
    },
    onPhotoLoading(state: boolean) {
      this.photoLoading = state
    },
    removeExistingPhoto(photoKey: string) {
      this.photosToRemove.push(photoKey)
      let existingIndex = this.photos.findIndex((photo: string) => {
        return photo === photoKey
      })
      this.photos.splice(existingIndex, 1)
    },
    removeRequiredAction(toRemove: CulvertInspectionActionRes): void {
      if (!this.selectedActionsRequired) return
      let index = this.selectedActionsRequired.findIndex(
        (action: CulvertInspectionActionRes) => {
          return action.id === toRemove.id
        }
      )
      if (index >= 0) this.selectedActionsRequired.splice(index, 1)
    },
    removeTakenAction(toRemove: CulvertInspectionActionRes): void {
      if (!this.selectedActionsTaken) return
      let index = this.selectedActionsTaken.findIndex(
        (action: CulvertInspectionActionRes) => {
          return action.id === toRemove.id
        }
      )
      if (index >= 0) this.selectedActionsTaken.splice(index, 1)
    },
    exit() {
      this.exitDialog = false
      this.confirmedLeaving = true
      if (this.routerNextPath === '')
        this.routerNextPath = '/culvert-inspections'

      this.$router.push({ path: this.routerNextPath })
    },
    clearEdits(): void {
      this.setFormData()
      //@ts-ignore
      this.$refs.photoComp.displayExistingPhotos(this.photos)
    }
  },
  //@ts-ignore
  beforeRouteLeave(to, from, next) {
    if (to.path) {
      this.routerNextPath = to.path
    }
    if (this.inspectionSaved) {
      this.exitDialog = false
      next()
    } else if (!this.inspectionSaved && !this.confirmedLeaving) {
      this.exitDialog = true
      /*
        warning  [Vue warn]: Error in v-on handler (Promise/async): "Error: Navigation aborted from "/culvert-inspections/edit" to "/culvert-inspections" via a navigation guard."
        is caused by the call to next(false), it is nothing to be concerned with.
      */
      next(false)
    } else if (!this.inspectionSaved && this.confirmedLeaving) {
      next()
    }
  },
  created() {
    if (this.$route.params.id) {
      try {
        let idToFind = parseInt(this.$route.params.id.toString())

        let foundInspection = this.culvertInspections.find((inspection) => {
          return inspection.id === idToFind
        })

        if (foundInspection) {
          this.inspectionToEdit = foundInspection
        }
      } catch (e) {
        console.log('inspectionId not a number')
        this.$router.back()
        this.$typedStore.commit('setSnackbarParams', {
          type: 'error',
          msg: 'Error finding inspection to edit.'
        })
        return
      }
    } else {
      this.$router.back()
      this.$typedStore.commit('setSnackbarParams', {
        type: 'error',
        msg: 'Error finding inspection to edit.'
      })
      return
    }

    if (this.culverts.length > 0 && this.watchPosition && IsMobileDevice()) {
      this.sortCulvertList(this.watchPosition)
    } else {
      this.sortCulvertList()
    }
    this.setFormData()
  }
})

interface AddCulvertInspectionI {
  selectedCulvert: number | null
  previousCulvertId: number | null
  selectedActionsRequired: CulvertInspectionActionRes[]
  selectedActionsTaken: CulvertInspectionActionRes[]
  selectedCulvertStatus: number | null
  inspectionToEdit: CulvertInspectionResult | null

  comments: string
  date: string
  time: string
  nextDate: string
  dateDialog: boolean
  timeDialog: boolean
  nextDateDialog: boolean
  confirmationDialog: boolean
  fullCulvertList: CulvertWithDistanceToUser[]
  pageLoading: boolean
  photos: string[]
  newPhotos: Blob[]
  photosToRemove: string[]
  photoLoading: boolean
  riskSlider: number
  riskLabels: string[]
  isMobileDevice: boolean
  actionsRequiredSelectMenu: boolean
  actionsTakenSelectMenu: boolean

  inspectionSaved: boolean
  exitDialog: boolean
  confirmedLeaving: boolean
  routerNextPath: string
  haveActionsTaken: boolean
  haveActionsRequired: boolean
}

interface CulvertWithDistanceToUser {
  culvert: CulvertResult
  distance: number
}
